// @flow
import React from 'react';

type Props = {
  fill: string
}

const strokeWidth = 2.5;

const ClickAwayIcon = ({ fill }: Props) => (
  <svg
    viewBox="0 0 110 110"
    width="100%"
  >
    <path
      fill="#fff"
      d="M33.73 102.86a50.52 50.52 0 0 1-10-5.54c-3.07-2.4-6.44-4.6-8.83-7.58s-3-7.2-4.68-10.66-4-6.64-4.9-10.4-.78-7.63-.8-11.5-.8-7.84
      0-11.65 3.58-6.84 5.23-10.4S12.78 28 15.05 25s5.46-5.38 8.37-7.83 5.78-5.05 9.18-6.8 6.73-4.18
      10.45-5.15 7.8.14 11.65 0 7.62-.5 11.43.28S73.23 8 76.8 9.64a49.7 49.7 0 0 1 9.9 5.65c3.08 2.4
      5.32 5.4 7.7 8.38s5.13 5.75 6.8 9.2a52.1 52.1 0 0 1 4.1 10.8 52.84 52.84 0 0 1 1.75 11.48c0
      3.8-1.25 7.6-2.08 11.4s-1.36 7.6-3 11.17a54.26 54.26 0 0 1-5.93 10c-2.36 3.1-6 5-8.88 7.4a50.28
      50.28 0 0 1-9.35 6.47c-3.4 1.78-6.5 4.6-10.22 5.58s-7.8-.4-11.67-.28-7.73
      1.35-11.54.56-7.06-2.95-10.63-4.6z"
    />
    <path
      style={{ fill }}
      d="M68.15 5.28a40.1 40.1 0 0 0-13.52-2.36c-17.52 0-33.08 11.57-41.53 24.7C.5 47.2 1.17 71.36
      14.75 87.73c14.2 17.13 37.66 23 57 14.32 10.83-4.87 25-16 30.56-29a29.75 29.75 0 0 0
      2.2-12.14v-.38l.25-.3a1.8 1.8 0 0 0 .4-.82c2.3-10.06-1-21.66-9.17-32.64-7.36-9.9-17.78-17.92-27.83-21.5zm29
      31.17l3.44 7s3.6 16.25-3 27.85c-6.34 11.06-18.7 22.1-28.9 26.62a41.93 41.93 0 0 1-16.9 3.5A44.5 44.5
      0 0 1 30.54 96 41.57 41.57 0 0 1 9 65.92C5.4 43.16 20.42 18 42.44 9.8 56.24 4.65 71.7 8.1 83.8
      19a59.78 59.78 0 0 1 13.35 17.45z"
    />
    <path
      style={{ stroke: fill, strokeWidth: strokeWidth }}
      fill="#fff"
      d="M82.75 60.33A27.62 27.62 0 1 1 55.13 32.7a27.62 27.62 0 0 1 27.62 27.63z"
    />
    <path
      style={{ stroke: fill, strokeWidth: strokeWidth }}
      fill="#fff"
      d="M37.1 63.4s3.85 11.5 16.5 13c0 0 13.43.37 18-13"
      strokeLinecap="round"
    />
    <path
      style={{ stroke: fill, strokeWidth: strokeWidth }}
      fill="none"
      d="M68.7 59.68l6.5 6.52M39.54 59.8l-6.52 6.53"
    />
    <path
      style={{ fill }}
      d="M51.17 47.4c0 2.83-1.34 5.12-3 5.12s-3-2.3-3-5.1 1.35-5.13 3-5.13 3 2.28 3 5.1zM63.58 47.4c0
      2.83-1.35 5.12-3 5.12s-3-2.3-3-5.1 1.34-5.13 3-5.13 3 2.28 3 5.1zM22.15 36.7a1.6 1.6 0
      0 1-.26-.8 1.15 1.15 0 0 1 .24-.8 1.17 1.17 0 0 1 .7-.46 1.55 1.55 0 0 1 .86.06l6.54
      2.1.26.1a.76.76 0 0 1 .15.1.75.75 0 0 1 .3.54.85.85 0 0 1-.18.6.86.86 0 0 1-.5.34 1.07 1.07 0 0
      1-.52 0l-1.1-.4-2 2.6.65 1a1 1 0 0 1 .18.52.77.77 0 0 1-.2.55.9.9 0 0 1-.57.35.76.76 0 0
      1-.62-.16 1.35 1.35 0 0 1-.17-.17l-.08-.14zm3.5 2.54L27 37.46l-3.4-1.24zM31.14 31.62a5 5 0 0
      1-.78-1.56 4.05 4.05 0 0 1-.15-1.6 4 4 0 0 1 .5-1.53 3.94 3.94 0 0 1
      1.13-1.26c.18-.12.4-.26.65-.4a4.22 4.22 0 0 1 .8-.33 2.18 2.18 0 0 1 .8-.07.84.84 0 0
      1 .6.35.87.87 0 0 1 .17.57.65.65 0 0 1-.3.5.92.92 0 0 1-.3.16l-.4.1a4.27 4.27 0 0 0-.45.16 3.07
      3.07 0 0 0-.55.33A2 2 0 0 0 32 28.7a2.43 2.43 0 0 0 .17.93 3.3 3.3 0 0 0 .5.92 3.52 3.52 0 0
      0 .7.73 2.52 2.52 0 0 0 .85.4 2.1 2.1 0 0 0 .9 0 2.14 2.14 0 0 0 .9-.4 2.3 2.3 0 0 0 .48-.44 4.28
      4.28 0 0 0 .3-.43c.07-.13.14-.25.2-.37a.78.78 0 0 1 .25-.27.67.67 0 0 1 .33-.14.9.9 0 0 1 .33
      0 .84.84 0 0 1 .28.13.73.73 0 0 1 .18.16.93.93 0 0 1 .18.76 2.1 2.1 0 0 1-.32.76 3.78 3.78 0 0
      1-.58.7 5.87 5.87 0 0 1-.6.5 4 4 0 0 1-1.53.73 4 4 0 0 1-3.08-.6 4.84 4.84 0 0 1-1.28-1.13zM36
      23.5a1 1 0 0 1-.1-.73.87.87 0 0 1 1.1-.58 1 1 0 0 1 .52.5L41 29.17a1 1 0 0 1 .1.72.87.87 0 0
      1-1.1.58 1 1 0 0 1-.52-.5zM39.56 21a.86.86 0 0 1 .36-.07 1.16 1.16 0 0 1 .37.07 1 1 0 0 1 .3.2.86.86
      0 0 1 .2.3 1 1 0 0 1 0 .74 1 1 0 0 1-.5.54.78.78 0 0 1-.38.06 1.17 1.17 0 0 1-.37-.08 1 1 0 0
      1-.55-.56.86.86 0 0 1-.07-.36 1 1 0 0 1 .1-.36 1 1 0 0 1 .2-.3 1 1 0 0 1 .33-.18zm.56 3.58a1 1 0 0 1
      0-.73.82.82 0 0 1 .47-.48.8.8 0 0 1 .67 0 1 1 0 0 1 .48.55l1.76 4.2a1 1 0 0 1 0 .74.8.8 0 0
      1-.46.48.8.8 0 0 1-.67 0 1 1 0 0 1-.48-.55zM48 22.05a.86.86 0 0 1 0 .28.77.77 0 0 1-.06.3.72.72 0 0
      1-.14.24.44.44 0 0 1-.25.14.85.85 0 0 1-.32 0h-.59a1.7 1.7 0 0 0-.38 0 1.4 1.4 0 0 0-.58.3 1.33 1.33
      0 0 0-.33.5 2 2 0 0 0-.12.6 2.82 2.82 0 0 0 .08.66 2.2 2.2 0 0 0 .27.6 1.8 1.8 0 0 0 .4.45 1.57 1.57 0
      0 0 .54.28 1.23 1.23 0 0 0 .64 0 1.12 1.12 0 0 0 .33-.14 2.7 2.7 0 0 0 .33-.22l.28-.2a1.52 1.52 0 0
      1 .2-.1.76.76 0 0 1 .57.07.77.77 0 0 1 .25 1.05 1.85 1.85 0 0 1-.47.5 3 3 0 0 1-.62.36 3.68 3.68 0 0
      1-.54.22 2.92 2.92 0 0 1-2.4-.37 3.55 3.55 0 0 1-.87-.86 3.66 3.66 0 0 1-.54-1.18 3.6 3.6 0 0 1
      .23-2.46 3.16 3.16 0 0 1 .75-.95 2.7 2.7 0 0 1 1.13-.57 5.07 5.07 0 0 1 .6-.1 4.33 4.33 0 0 1 .72 0
      1.73 1.73 0 0 1 .62.17.64.64 0 0 1 .28.45zM49.46 19a1 1 0 0 1 .2-.7.87.87 0 0 1 1.23-.08 1 1 0 0 1
      .27.67l.27 4 1.75-1.95a1.5 1.5 0 0 1 .38-.3 1.13 1.13 0 0 1 .36-.12.7.7 0 0 1 .54.2.88.88 0 0 1
      .2.88 1 1 0 0 1-.25.35L53 23.38l2.16 2.2a.7.7 0 0 1 .2.28 1 1 0 0 1 .06.3.8.8 0 0 1-.2.58.8.8 0 0
      1-.56.27.7.7 0 0 1-.43-.1 1.88 1.88 0 0 1-.42-.36l-2.25-2.43.14 2.1a1 1 0 0 1-.2.7.86.86 0 0
      1-1.23.07 1 1 0 0 1-.27-.67zM62.87 20.05a1.72 1.72 0 0 1 .64-.56 1.14 1.14 0 0 1 .84-.1 1.17 1.17 0
      0 1 .7.45 1.76 1.76 0 0 1 .3.8l.78 6.83a1.26 1.26 0 0 1 0 .27c0 .08 0 .14 0 .18a.75.75 0 0
      1-.37.5.86.86 0 0 1-.6.07.85.85 0 0 1-.53-.3 1 1 0 0 1-.18-.5l-.1-1.17-3.2-.77-.6 1a1 1 0 0
      1-.4.38.82.82 0 0 1-.6 0 1 1 0 0 1-.54-.34.77.77 0 0 1-.1-.64.87.87 0 0 1 .07-.23l.1-.14zM62
      24.28l2.2.53-.28-3.6zM68.4 24.26q0-.27.1-.45a1.28 1.28 0 0 1 .13-.34.6.6 0 0 1 .43-.3.9.9 0 0
      1 .65.1.78.78 0 0 1 .38.4.92.92 0 0 1 0 .58l-.68 3.35 2.4-2.36a1.33 1.33 0 0 1 .5-.34.75.75 0 0
      1 .6.1.74.74 0 0 1 .42.45 1.08 1.08 0 0 1 0 .62l-.63 3.3L75.16 27a1 1 0 0 1 .48-.3.77.77 0 0
      1 .55.08.87.87 0 0 1 .44.5.8.8 0 0 1-.08.64 1.3 1.3 0 0 1-.18.23l-.27.26-3.23 2.95a1.7 1.7 0 0
      1-.63.37.87.87 0 0 1-.7-.1.9.9 0 0 1-.45-.48 1.2 1.2 0 0 1 0-.7l.52-2.83-2.08 2a1.27 1.27 0 0
      1-.6.36 1.06 1.06 0 0 1-1.1-.64 1.48 1.48 0 0 1 0-.73zM79.28 36.6l-.26.25a.9.9 0 0 1-.32.2.62.62 0
      0 1-.36 0 .92.92 0 0 1-.43-.25.74.74 0 0 1-.26-.52 1.26 1.26 0 0 1 .17-.57 2 2 0 0 1-1.7-.53 2.52
      2.52 0 0 1-.66-1 2.8 2.8 0 0 1-.2-1.1 3.12 3.12 0 0 1 .3-1.07 4 4 0 0 1 .75-1.12 4.17 4.17 0 0 1
      1.05-.8 3.25 3.25 0 0 1 1.17-.34 2.85 2.85 0 0 1 1.13.1 2.58 2.58 0 0 1 1 .58 2.22 2.22 0 0
      1 .53.76 1.72 1.72 0 0 1 .1.93.75.75 0 0 1 .56-.17.82.82 0 0 1 .54.22.9.9 0 0 1 .27.4.7.7 0 0 1
      0 .4 1.14 1.14 0 0 1-.18.3l-.24.28zm-1.74-4.55a2.08 2.08 0 0 0-.37.5 1.94 1.94 0 0 0-.2.58 1.27
      1.27 0 0 0 0 .58 1.05 1.05 0 0 0 .33.53 1 1 0 0 0 .53.3 1.22 1.22 0 0 0 .57 0 1.74 1.74 0 0
      0 .55-.24 2.1 2.1 0 0 0 .5-.4 3.08 3.08 0 0 0 .36-.5 2.13 2.13 0 0 0 .22-.58 1.62 1.62 0 0 0
      0-.58 1.2 1.2 0 0 0-.87-.82 1.3 1.3 0 0 0-.6 0 1.7 1.7 0 0 0-.55.23 2.68 2.68 0 0 0-.46.4zM83.17
      34.77a1.83 1.83 0 0 1 .13-.16.93.93 0 0 1 .18-.15.56.56 0 0 1 .28-.1.8.8 0 0 1 .3 0 1 1 0 0 1
      .3.12.9.9 0 0 1 .2.2.9.9 0 0 1 .16.52.92.92 0 0 1-.17.5l-2 2.84 3.45-.82a.93.93 0 0 1 .55 0 .86.86
      0 0 1 .44.34.83.83 0 0 1 .1.25 1 1 0 0 1 0 .3 1 1 0 0 1-.07.3.54.54 0 0 1-.2.24.9.9 0 0
      1-.4.2l-7.47 1.8a1.56 1.56 0 0 1-.57 0 .65.65 0 0 1-.47-.3.93.93 0 0 1-.2-.68.7.7 0 0 1 .3-.47.85.85
      0 0 1 .2-.14l.26-.08 2-.46z"
    />
  </svg>
);

ClickAwayIcon.defaultProps = {
  fill: '#000'
};

export default ClickAwayIcon;